import Box from '@mui/material/Box';
import _ from 'react';

const Legal = () => {
  return <Box>Legal Placeholder</Box>;
};

export default Legal;
